import StatSpy from './stat-spy.js';

// Default options for the plugin.
const DEFAULTS = {
	mediaType: 'long', // 'short', 'live'
	freqInterval: 0,
	data: {
		ns_st_cl: function() {
			return this.player.duration() * 1000;
		}
	},
	adData: {
		ns_st_cl: function() {
			if (this.player.vast.adUnit.adDuration) {
				return this.player.vast.adUnit.adDuration() * 1000;
			} else if (this.player.vast.adUnit.vpaid) {
				return this.player.vast.vastResponse.duration || 
					   this.player.vast.adUnit.vpaid._creative.getAdDuration() * 1000;
			} else {
			 	return this.player.duration() * 1000;
			}
		}
	},
	//contentStartEvents: ['vast.contentPlay'],
	//adStartEvents: ['vast.adStart'],
	//stopEvents: ['vast.contentPause', 'vast.adFinish', 'contentError', 'vast.contentEnd', 'interrupt'],
	contentStartEvents: ['vast.nativeContentPlay', 'timeupdateResume'],
	adStartEvents: ['vast.adStart', 'vast.nativeAdPlay'], // adStart for vpaid (no nativeAdPlay may be)
	stopEvents: ['pause', 'vast.adFinish', 'contentError', 'vast.contentEnd', 'interrupt', 'timeupdateSuspend'],
	libPath: 'videojs-stat/libs/streamsense.5.2.0.160629.min.js' // used if options.libPath == null
};

/**
 * The Stat class to send ComScore stat.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatSpy
 */

class StatComscore extends StatSpy {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		options_.data = Object.assign({}, DEFAULTS.data, options.data);
		options_.adData = Object.assign({}, DEFAULTS.adData, options.adData);
		options_.events = options_.contentStartEvents
			.concat(options_.adStartEvents
			.concat(options_.stopEvents));
		options_.libPath = options_.libPath == null ? DEFAULTS.libPath : options.libPath;
		super(player, options_);

		this.clientId = options_.clientId;
		this.mediaType = options_.mediaType;
		this.metadata = options_.data;
		this.adMetadata = options_.adData;
		this.contentStartEvents = options_.contentStartEvents;
		this.adStartEvents = options_.adStartEvents;
		this.stopEvents = options_.stopEvents;
		this.tag = null;
		this.player = player;
		this.lastCommand = 'stop';

		this.utils.loadScript(options_.libPath, () => this.init());
	}

	init() {
		this.tag = new ns_.StreamingTag({customerC2: this.clientId});
		this.player.on('vast.lastPostrollEnd', () => {
			this.tag = new ns_.StreamingTag({customerC2: this.clientId});
		});
		this.contentMediaType = this.getContentMediaType(this.mediaType);
	}

	send(ev) { 
		super.send(ev);
		if (this.contentStartEvents.includes(ev)) {
			if (this.lastCommand !== 'stop') return;
			this.tag.playVideoContentPart(this.utils.proceedData(this.metadata, this, ev), this.contentMediaType);
			this.lastCommand = 'play';
		} else if (this.adStartEvents.includes(ev)) {
			if (this.lastCommand !== 'stop') return;
			this.tag.playVideoAdvertisement(this.utils.proceedData(this.adMetadata, this, ev), this.getAdMediaType());
			this.lastCommand = 'play';
		} else if (this.stopEvents.includes(ev)) {
			if (this.lastCommand !== 'play') return;
			this.tag.stop();
			this.lastCommand = 'stop';
		}
	}

	getContentMediaType(type = '') { 
		type = this.utils.capitalizeFirst(type);
		type = type === 'Live' ? type : type + 'FormOnDemand';
		return ns_.StreamingTag.ContentType[type]; 
	}

	getAdMediaType() { 
		var type = (this.player.vast.curAd || {}).type || '';
		if (type == 'pause_roll') type = 'mid_roll';
		type = type.split('_').reduce((res, el) => this.utils.capitalizeFirst(res) + this.utils.capitalizeFirst(el));
		return ns_.StreamingTag.AdType['LinearOnDemand' + type];
	}	
}

export default StatComscore;
